<!-- eslint-disable vue/multi-word-component-names -->

<script setup>
import { ref } from 'vue';


let images = ref([
    "35.webp",
]);



</script>

<template>
   <main class="w-full h-auto my-2">

    <section class="container mx-auto h-auto flex flex-col justify-start items-center">
      <span class="font-bold text-xl">Products / Ophtalmology </span>

      <section class="w-11/12 h-auto  grid grid-cols-1 md:grid-cols-3 gap-2 box-border p-2">
        <div :key="index" class="w-full h-full col-span-1 flex justify-center items-center" v-for="(item,index) in items">
            <div class="w-3 h-3 bg-sky-500 rounded-full"></div>
            <span class="mx-2">{{ item }}</span>
        </div>
      </section>

      <section class="w-11/12 h-auto  grid grid-cols-1 md:grid-cols-3 gap-2 box-border p-2">

        <a :key="index" download :href="`/ophtalmology/${item}`"  v-for="(item,index) in images" class="w-full h-[250px] rounded-lg col-span-1 flex justify-center items-center">
            <img  :src="`/ophtalmology/${item}`" class="w-full h-full object-contain " alt="">
        </a>

      </section>

    </section>
  </main>
</template>

<style scoped></style>